module.exports = __webpack_public_path__ + "img/icon_warning_black.0819d965.svg";